export default __webpack_public_path__ + "static/dot-pattern-olive-group-48a00efa85ea4edefbe30714124e4faf.svg";